import { render, staticRenderFns } from "./AiAdvicePlans.vue?vue&type=template&id=670a7398&"
import script from "./AiAdvicePlans.vue?vue&type=script&lang=ts&"
export * from "./AiAdvicePlans.vue?vue&type=script&lang=ts&"
import style0 from "./AiAdvicePlans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports